import AircallWorkspace from './src/javascripts/aircallWorkspace.js';

export default AircallWorkspace;
